<template>
  <div>
    <div class="arrivalNavigation">
      <div class="d4"></div>
      <div class="sideNavigation">
        <ul v-for="(item, index) in list" :key="item.id">
          <li @click="checkItem(item.id)">
            <el-radio :title="item.name"  class="task_li" v-model="current" :label="item.id">{{ item.name }}</el-radio>
          </li>
          <!-- <li @click="checkItem(item.id)">{{item.name}}<radio style="float: right;" :value="getSreing(item.id)" :checked="current===item.id"/></li> -->
          <div v-if="index < list.length - 1" class="liBottomBorder"></div>
        </ul>
      </div>
    </div>
  </div>
</template>
	
<script>
export default {
  props: {
    list: {
      type: Array,
      default: []
    },
    currentCheckItem:{
				type:Number,
				default:0
			}
  },
  data() {
    return {
      current:this.currentCheckItem,
    };
  },
  methods: {
    getSreing(val) {
      return val.toString()
    },
    // 点击页面事件 隐藏需要隐藏的区域
    HiddenClick() {
      this.ShowHidden = false
    },
    checkItem(id) {
      this.current = id
      this.$emit('checkItem',id)
    },
  },
}
</script>
	
<style lang="scss" scoped>
.tooltip_item {
  position: relative;
  z-index: 99999999;
}
.arrivalSearch {
  width: 100%;
  height: 50px;
  background-color: #fff;
  box-shadow: 0 0 5px #eee;

  .arrivalSmallsearch {
    width: 96%;
    display: flex;

    .arrivalSearchInput {
      height: 35px;
      background-color: #F0F1F6;
      border-radius: 20px;
      font-size: 20px;
      margin-left: 5px;
      margin-top: 5px;
      width: 300px;
    }

    input {
      width: 80%;
      margin-left: 20px;
      margin-top: 5px;
    }

    image {
      width: 20px;
      height: 20px;
      margin-left: 10px;
      margin-top: 10px;
    }
  }

}

.arrivalNavigation {
  width: 200px;

  position: absolute;
  right: 10px;

  .sideNavigation {
    width: 180px;
    height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #eff7ff;
    color: #333333;
    border-radius: 5px;

    ul {
      padding: 0;
    }

    li {
      list-style-type: none;
      height: 45px;
      text-align: start;
      line-height: 45px;
      padding: 0 15px;
      font-size: 15px;

      radio {
        transform: scale(0.6);
      }

      .task_li {
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .liBottomBorder {
      border-bottom: 1px solid #FFFFFF;
    }

  }

  .d4 {
    position: absolute;
    width: 0;
    height: 0;
    bottom: -15px;
    left: 15px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent #eff7ff transparent transparent;
    transform: rotate(270deg);
  }
}</style>